import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import {
  addNote,
  editNote,
  listNoteByMessageId,
  queryNoteBySessionId,
  removeNote,
} from "./thunkAction";

const initialState = {
  notes: {},
  note: {},
  sessionNotes: [],
  targetMessageId: null,
  total: 0,
  skip: 0,
  limit: 3,
  loading: false,
  error: null,
  isLoadingAddNote: false,
  addNoteError: null,
};

const noteSlice = createSlice({
  name: "noteManage",
  initialState,
  reducers: {
    clearNote(state) {
      state.notes = {};
      state.note = {};
      state.sessionNotes = [];
      state.skip = 0;
      state.limit = 3;
      state.total = 0;
    },
    selectNote(state, action) {
      state.note = _.get(action, "payload", {});
    },
    resetProfileError(state) {
      state.error = null;
    },
    setTargetMessageId(state, action) {
      state.targetMessageId = _.get(action, "payload", null);
    },
    clearTargetMessageId(state) {
      state.targetMessageId = null;
    },
    clearNoteByMessageId(state, action) {
      const messageId = _.get(action, "payload");
      if (messageId) {
        state.notes[messageId] = [];
      }
    },
    setSkip(state, action) {
      state.skip = _.get(action, "payload", 0);
    },
    setLimit(state, action) {
      state.limit = _.get(action, "payload", 10);
    },
    setNotes(state, action) {
      const notes = _.get(action, "payload", []);
      const messageId = _.get(notes, "0.messageId");
      if (messageId) {
        state.notes[messageId] = notes;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // listNoteByMessageId
      .addCase(listNoteByMessageId.pending, (state) => {
        state.loading = true;
      })
      .addCase(listNoteByMessageId.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        const notes = _.get(action, "payload", []);
        const messageId = _.get(notes, "0.messageId");
        if (messageId) {
          state.notes[messageId] = notes;
        }
      })
      .addCase(listNoteByMessageId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // addNote
      .addCase(addNote.pending, (state) => {
        state.isLoadingAddNote = true;
        state.addNoteError = null;
      })
      .addCase(addNote.fulfilled, (state, action) => {
        state.isLoadingAddNote = false;
        state.notes = _.get(action, "payload", {});
      })
      .addCase(addNote.rejected, (state, action) => {
        state.isLoadingAddNote = false;
        state.addNoteError = action.payload;
      })
      //editNote
      .addCase(editNote.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editNote.fulfilled, (state, action) => {
        state.loading = false;
        state.note = _.get(action, "payload", {});
      })
      .addCase(editNote.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //editNote
      .addCase(removeNote.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeNote.fulfilled, (state, action) => {
        state.loading = false;
        state.note = _.get(action, "payload", {});
      })
      .addCase(removeNote.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //queryNoteBySessionId
      .addCase(queryNoteBySessionId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(queryNoteBySessionId.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;

        const data = _.get(action, "payload", {});
        const notes = _.get(data, "data", []);
        const mergedNotes = [...notes, ...state.sessionNotes];
        state.sessionNotes = _.sortBy(mergedNotes, "addTime");
        state.total = _.get(data, "metadata.total", 0);
      })
      .addCase(queryNoteBySessionId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const noteReducer = noteSlice.reducer;

export const noteAction = noteSlice.actions;
